import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export const deleteRecentSearch = async (query: string): Promise<void> => {
  const response = await api.search.deleteSearch.mutation({
    body: { query },
  });

  if (response.status === 200) {
    return;
  }

  throw new ApiError("Failed to delete recent search", response.status, response.body);
};
